import React from 'react';
import { Box } from '@material-ui/core';
import BuzzInput from '../BuzzInput/BuzzInput';
import BuzzSelect from '../BuzzSelect/BuzzSelect';
import BuzzMultiSelect from '../BuzzMultiSelect/BuzzMultiSelect';
import BuzzLabel from '../BuzzLabel/BuzzLabel';
import BuzzArray from '../BuzzArray/BuzzArray';
import BuzzCheckbox from '../BuzzCheckBox/BuzzCheckbox';
import BuzzPassword from '../BuzzPassword/BuzzPassword';

import BuzzAutoCompleteMultiSelectInput from '../BuzzAutoCompleteInput/BuzzAutoCompleteMultiSelectInput';
import BuzzAutoCompleteSingleSelectInput from '../BuzzAutoCompleteInput/BuzzAutoCompleteSingleSelectInput';
import BuzzMapInput from '../BuzzMapInput/BuzzMapInput';

function FormRenderer({ formTemplate, formData, setFormData }) {
  return (
    <Box alignItems="center" mt={2}>
      {formTemplate &&
        formTemplate.map((formField) => {
          if (formField.type === 'Number')
            return (
              <Box key={formField.id} my={2}>
                <BuzzInput
                  type="number"
                  label={formField.title}
                  value={formData[formField.slug]}
                  placeholder={formField.placeholder}
                  onChange={(e) => {
                    let newValue = e.target.value;
                    if (formField.onChange)
                      newValue = formField.onChange(parseInt(newValue));

                    if (!Number.isNaN(newValue))
                      setFormData(formField.slug, parseInt(newValue));
                  }}
                  required={formField.required}
                  disabled={formField.disabled}
                />
              </Box>
            );
          if (formField.type === 'FloatNumber')
            return (
              <Box key={formField.id} my={2}>
                <BuzzInput
                  type="number"
                  label={formField.title}
                  value={formData[formField.slug]}
                  placeholder={formField.placeholder}
                  onChange={(e) => {
                    let newValue = e.target.value;
                    if (formField.onChange)
                      newValue = formField.onChange(parseFloat(newValue));

                    if (!Number.isNaN(newValue))
                      setFormData(formField.slug, parseFloat(newValue));
                  }}
                  required={formField.required}
                />
              </Box>
            );
          else if (formField.type === 'String')
            return (
              <Box key={formField.id} my={2}>
                <BuzzInput
                  type="text"
                  label={formField.title}
                  value={formData[formField.slug]}
                  placeholder={formField.placeholder}
                  onChange={(e) => {
                    let newValue = e.target.value;
                    if (formField.onChange)
                      newValue = formField.onChange(newValue);

                    setFormData(formField.slug, newValue);
                  }}
                  required={formField.required}
                />
              </Box>
            );
          else if (formField.type === 'Password')
            return (
              <BuzzPassword
                label={formField.title}
                value={formData[formField.slug]}
                placeholder={formField.placeholder}
                onChange={(e) => {
                  setFormData(formField.slug, e.target.value);
                }}
                required={formField.required}
              />
            );
          else if (formField.type === 'Boolean')
            return (
              <Box key={formField.id} my={2}>
                <BuzzCheckbox
                  label={formField.title}
                  checked={formData[formField.slug] || false}
                  onChange={(e) =>
                    setFormData(formField.slug, e.target.checked)
                  }
                />
              </Box>
            );
          else if (formField.type === 'Select')
            return (
              <Box key={formField.id} my={2}>
                <BuzzSelect
                  size="small"
                  label={formField.title}
                  valueKey="value"
                  labelKey="label"
                  options={formField.options}
                  value={formData[formField.slug]}
                  onChange={(e) => setFormData(formField.slug, e.target.value)}
                  required={formField.required}
                />
              </Box>
            );
          else if (formField.type === 'MultiSelect')
            return (
              <Box key={formField.id} my={2}>
                <BuzzMultiSelect
                  label={formField.title}
                  valueKey="value"
                  labelKey="label"
                  options={formField.options}
                  value={formData[formField.slug]}
                  onChange={(e) => {
                    setFormData(formField.slug, e.target.value);
                  }}
                  required={formField.required}
                />
              </Box>
            );
          else if (formField.type === 'Date')
            return (
              <Box key={formField.id} my={2}>
                <BuzzLabel
                  label={formField.title}
                  required={formField.required}
                  id={formField.id}
                />
                <input
                  type="date"
                  value={formData[formField.slug]}
                  onChange={(e) => {
                    setFormData(formField.slug, e.target.value);
                  }}
                  style={{
                    display: 'block',
                    width: '95%',
                    border: '1px solid rgba(0, 0, 0, 0.1)',
                    padding: '1rem 0.5rem',
                    borderRadius: '5px',
                    fontFamily: 'Rubik',
                  }}
                />
              </Box>
            );
          else if (formField.type === 'Array')
            return (
              <Box key={formField.id} my={2}>
                <BuzzArray
                  id={formField.id}
                  label={formField.title}
                  arrayElementType={formField.arrayElementType}
                  value={formData[formField.slug]}
                  onChange={(value) => {
                    setFormData(formField.slug, value);
                  }}
                  disableExistingSlugs={formField.disableExistingSlugs}
                />
              </Box>
            );
          else if (formField.type === 'AutoCompleteSelect')
            return (
              <Box key={formField.id} my={2}>
                <BuzzAutoCompleteSingleSelectInput
                  id={formField.id}
                  label={formField.title}
                  options={formField.options}
                  value={formData[formField.slug]}
                  onChange={(value) => {
                    setFormData(formField.slug, value);
                  }}
                  required={formField.required}
                />
              </Box>
            );
          else if (formField.type === 'AutoCompleteMultiSelect')
            return (
              <Box key={formField.id} my={2}>
                <BuzzAutoCompleteMultiSelectInput
                  id={formField.id}
                  label={formField.title}
                  options={formField.options}
                  value={formData[formField.slug]}
                  onChange={(value) => {
                    setFormData(formField.slug, value);
                  }}
                  freeSolo={formField.freeSolo}
                  required={formField.required}
                  disabled={formField.disabled}
                />
              </Box>
            );
          else if (formField.type === 'Map')
            return (
              <BuzzMapInput
                id={formField.id}
                label={formField.title}
                value={formData[formField.slug]}
                onChange={(value) => {
                  setFormData(formField.slug, value);
                }}
              />
            );
          else return <p>Invalid Input type - {formField.type}</p>;
        })}
    </Box>
  );
}

export default FormRenderer;
